import { DomainSchema } from '@multitec/domain'
import { z } from 'zod'

import { Base } from '../base'

class Login extends Base {
  private body = z.object({
    username: z.string(),
    password: z.string(),
  })

  private response = z.object({
    user: DomainSchema.User,
    token: z.string(),
    refresh_token: z.string(),
  })

  handle = async (body: z.infer<typeof this.body>) => {
    const { data } = await this.axios.post('/auth/login', this.body.parse(body))
    return this.response.parse(data.result)
  }
}

class LoginClient extends Base {
  private body = z.object({
    asset_number: z.string(),
    contract_password: z.string(),
  })

  private response = z.object({
    asset: z.object({
      ...DomainSchema.Asset.shape,
      Equipment: DomainSchema.Equipment,
    }),
    contract: z.object({
      ...DomainSchema.Contract.shape,
      Person: DomainSchema.Person,
    }),
    token: z.string(),
    refresh_token: z.string(),
  })

  handle = async (body: z.infer<typeof this.body>) => {
    const { data } = await this.axios.post(
      '/auth/login-client',
      this.body.parse(body),
    )
    return this.response.parse(data.result)
  }
}

class RefreshToken extends Base {
  private body = z.object({
    refresh_token: z.string(),
  })

  private response = z.object({
    user: DomainSchema.User,
    token: z.string(),
    refresh_token: z.string(),
  })

  handle = async (body: z.infer<typeof this.body>) => {
    const { data } = await this.axios.post(
      '/auth/token/refresh',
      this.body.parse(body),
    )
    return this.response.parse(data.result)
  }
}

export default class extends Base {
  Login = new Login(this.axios).handle
  LoginClient = new LoginClient(this.axios).handle
  RefreshToken = new RefreshToken(this.axios).handle
}
